<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.71967 3.71967C4.01256 3.42678 4.48744 3.42678 4.78033 3.71967C5.07322 4.01256 5.07322 4.48744 4.78033 4.78033L2.56066 7H13.4393L11.2197 4.78033C10.9268 4.48744 10.9268 4.01256 11.2197 3.71967C11.5126 3.42678 11.9874 3.42678 12.2803 3.71967L15.7803 7.21967C16.0732 7.51256 16.0732 7.98744 15.7803 8.28033L12.2803 11.7803C11.9874 12.0732 11.5126 12.0732 11.2197 11.7803C10.9268 11.4874 10.9268 11.0126 11.2197 10.7197L13.4393 8.5H2.56066L4.78033 10.7197C5.07322 11.0126 5.07322 11.4874 4.78033 11.7803C4.48744 12.0732 4.01256 12.0732 3.71967 11.7803L0.21967 8.28033C-0.0732233 7.98744 -0.0732233 7.51256 0.21967 7.21967L3.71967 3.71967Z"
    fill="currentColor"
  />
</svg>
